import Markdown from "markdown-to-jsx/react";
import DOMPurify from "isomorphic-dompurify";

import { cancellation_policies } from "lib/data/cancellation_policies";

import styles from "./InformationSection.module.scss";

const InformationSection = ({ experience }) => {
  const { more_info } = experience;
  const { accommodation, food, requirements, cancellation_policy } = more_info;

  const requirementList = Object.entries(requirements).map(
    (requirement, index) => {
      if (
        !requirement[0] ||
        !requirement[1] ||
        requirement[0] === "id" ||
        requirement[0] === "required_qualifications" ||
        requirement[0] === "__typename"
      ) {
        return;
      }

      const labelString = requirement[0].toString();
      const valueString = requirement[1].toString();
      const label = labelString.replace(/_/g, " ");
      const value = valueString.replace(/_/g, " ");

      return (
        <li key={index} className={`${styles.requirementItem}`}>
          <span>{requirement[0].includes("crb") ? "CRB Required" : label}</span>
          <span className={`${styles.value}`}>{value}</span>
        </li>
      );
    }
  );

  return (
    <div className={`text-container`}>
      {requirements && (
        <div>
          <h3 className={`${styles.heading}`}>Requirements</h3>
          <ul className={`${styles.requirementList} `}>{requirementList}</ul>
        </div>
      )}
      {requirements?.required_qualifications && (
        <>
          <h3 className={`${styles.heading}`}>Other Requirements</h3>
          <Markdown>
            {DOMPurify.sanitize(requirements?.required_qualifications)}
          </Markdown>
        </>
      )}

      {food && (
        <>
          <h3 className={`${styles.heading}`}>Food</h3>{" "}
          <Markdown>{DOMPurify.sanitize(food)}</Markdown>
        </>
      )}
      {accommodation && (
        <>
          <h3 className={`${styles.heading}`}>Accommodation</h3>{" "}
          <Markdown>{DOMPurify.sanitize(accommodation)}</Markdown>
        </>
      )}

      {cancellation_policy && cancellation_policies[cancellation_policy] && (
        <>
          <h3 className={`${styles.heading}`}>Cancellation Policy</h3>
          <Markdown>
            {DOMPurify.sanitize(cancellation_policies[cancellation_policy])}
          </Markdown>
        </>
      )}
    </div>
  );
};

export default InformationSection;
